var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimeline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 2.917c0-.69.56-1.25 1.25-1.25h10.833a1.25 1.25 0 110 2.5H6.25c-.69 0-1.25-.56-1.25-1.25z",
    fill: "#195DEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M1.667 2.5a.833.833 0 111.666 0v15a.833.833 0 01-1.666 0v-15z",
    fill: "#195DEE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.333 7.917c0-.69.56-1.25 1.25-1.25h4.167a1.25 1.25 0 110 2.5H9.583c-.69 0-1.25-.56-1.25-1.25z",
    fill: "#195DEE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M13.333 12.917c0-.69.56-1.25 1.25-1.25h2.5a1.25 1.25 0 010 2.5h-2.5c-.69 0-1.25-.56-1.25-1.25zM5.833 17.083c0-.69.56-1.25 1.25-1.25H8.75a1.25 1.25 0 010 2.5H7.083c-.69 0-1.25-.56-1.25-1.25z",
    fill: "#195DEE"
  })));
}
export default SvgTimeline;